var React = require('react');

function ArrowRightLarge (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","stroke":"#142B6F","strokeLinejoin":"round","strokeWidth":"6","d":"M4 27.4926L95 27.4926L4 27.4926ZM95 27.5L67.7053 51.5L95 27.5ZM95 27.5L67.7053 3.49999L95 27.5Z","clipRule":"evenodd"})),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"98","height":"55","fill":"#fff","transform":"translate(98 55) rotate(-180)"})))]);
}

ArrowRightLarge.defaultProps = {"width":"78.4","height":"55","fill":"none","viewBox":"0 0 98 55"};

module.exports = ArrowRightLarge;

ArrowRightLarge.default = ArrowRightLarge;
